// Mock data for vessel comments with version history
// Multiple comments for the same field enable VersionHistoryTableSection to render

export const mockVesselComments = [
  // Multiple comments for 'deadweight' field to show version history
  {
    id: 'comment-1',
    tab: 'basicvesseldata',
    field: 'deadweight',
    comment: '115,000 MT',
    createdBy: 'john.doe@maersktankers.com',
    responsibleUser: {
      email: 'john.doe@maersktankers.com',
      name: 'John Doe',
    },
    createdAt: '2026-04-15T10:00:00.000Z',
    updatedAt: '2026-04-15T10:00:00.000Z',
    hash: 'hash-1',
    hide: false,
  },
  {
    id: 'comment-2',
    tab: 'basicvesseldata',
    field: 'deadweight',
    comment: '114,500 MT',
    createdBy: 'jane.smith@maersktankers.com',
    responsibleUser: {
      email: 'jane.smith@maersktankers.com',
      name: 'Jane Smith',
    },
    createdAt: '2026-03-10T14:30:00.000Z',
    updatedAt: '2026-03-10T14:30:00.000Z',
    hash: 'hash-2',
    hide: false,
  },
  {
    id: 'comment-3',
    tab: 'basicvesseldata',
    field: 'deadweight',
    comment: '114,000 MT',
    createdBy: 'bob.wilson@maersktankers.com',
    responsibleUser: {
      email: 'bob.wilson@maersktankers.com',
      name: 'Bob Wilson',
    },
    createdAt: '2026-02-05T09:15:00.000Z',
    updatedAt: '2026-02-05T09:15:00.000Z',
    hash: 'hash-3',
    hide: false,
  },
  // Multiple comments for 'loa' field
  {
    id: 'comment-4',
    tab: 'basicvesseldata',
    field: 'loa',
    comment: '250.00 m',
    createdBy: 'john.doe@maersktankers.com',
    responsibleUser: {
      email: 'john.doe@maersktankers.com',
      name: 'John Doe',
    },
    createdAt: '2026-04-10T11:00:00.000Z',
    updatedAt: '2026-04-10T11:00:00.000Z',
    hash: 'hash-4',
    hide: false,
  },
  {
    id: 'comment-5',
    tab: 'basicvesseldata',
    field: 'loa',
    comment: '249.95 m',
    createdBy: 'jane.smith@maersktankers.com',
    responsibleUser: {
      email: 'jane.smith@maersktankers.com',
      name: 'Jane Smith',
    },
    createdAt: '2026-01-20T16:45:00.000Z',
    updatedAt: '2026-01-20T16:45:00.000Z',
    hash: 'hash-5',
    hide: false,
  },
  // Single comment for 'beam' field (no version history)
  {
    id: 'comment-6',
    tab: 'basicvesseldata',
    field: 'beam',
    comment: '44.00 m',
    createdBy: 'bob.wilson@maersktankers.com',
    responsibleUser: {
      email: 'bob.wilson@maersktankers.com',
      name: 'Bob Wilson',
    },
    createdAt: '2026-04-01T08:30:00.000Z',
    updatedAt: '2026-04-01T08:30:00.000Z',
    hash: 'hash-6',
    hide: false,
  },
]
